export function languageBrowser(): string {
  try {
    return new Intl.Locale(navigator.language).language?.toLowerCase() as string
  } catch {
    const langSplit = window.navigator.language.split('-')
    return langSplit[0]!.toLowerCase()
  }
}
